export function stableStringify(value: unknown): string {
  if (value === null || value === undefined) {
    return JSON.stringify(value)
  }

  if (Array.isArray(value)) {
    return `[${value.map((item) => stableStringify(item)).join(',')}]`
  }

  if (typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>)
      .filter(([, entryValue]) => entryValue !== undefined)
      .sort(([left], [right]) => left.localeCompare(right))
      .map(
        ([key, entryValue]) =>
          `${JSON.stringify(key)}:${stableStringify(entryValue)}`
      )
    return `{${entries.join(',')}}`
  }

  return JSON.stringify(value)
}

export function fnv1a64(input: string): string {
  let hash = BigInt('0xcbf29ce484222325')
  const prime = BigInt('0x100000001b3')
  const mask = BigInt('0xffffffffffffffff')

  for (let idx = 0; idx < input.length; idx++) {
    hash ^= BigInt(input.charCodeAt(idx))
    hash = (hash * prime) & mask
  }

  return hash.toString(16).padStart(16, '0')
}

export function wrapCanvasText(
  ctx: CanvasRenderingContext2D,
  text: string,
  maxWidth: number
) {
  const words = text.trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) {
    return ['']
  }

  const lines: string[] = []
  let currentLine = words[0]

  for (const word of words.slice(1)) {
    const candidateLine = `${currentLine} ${word}`
    if (measureCanvasTextWidth(ctx, candidateLine) <= maxWidth) {
      currentLine = candidateLine
      continue
    }

    lines.push(currentLine)
    currentLine = word
  }

  lines.push(currentLine)
  return lines
}

export function measureCanvasTextWidth(
  ctx: CanvasRenderingContext2D,
  text: string
) {
  return ctx.measureText(text).width
}

export function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max)
}

export function roundToDecimal(value: number, places: number) {
  const factor = 10 ** places
  return Math.round(value * factor) / factor
}

export function lerp(a: number, b: number, t: number) {
  return a + (b - a) * t
}
